// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__17ubA","tab":"Tabs_tab__1AeE-","tabActive":"Tabs_tabActive__2VW6G"};